export enum ServerErrorCode {
  CARD_NOT_FOUND = 'card-not-found'
}
